import { useEffect, useState } from "react";
import { Api } from "../../common/Api";
import { baseFilters, useFilters } from "../useFilters";

export const useReports = () => {
  const [data, setData] = useState({ total: 0, items: [] });
  const [loading, setLoading] = useState(false);

  const { filters, setFilters, refreshKey, search, refresh, reset, getFiltersData } = useFilters(
    { ...baseFilters(), pending: true },
    (params) => {
      return {
        pending: params.pending !== "false",
      };
    },
    false
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      Api.report
        .reports(getFiltersData())
        .then((res) => {
          setData(res.data.reports);
        })
        .finally(() => setLoading(false));
    };

    fetchData();
  }, [refreshKey]);

  const onSearch = () => {
    search({ page: 0 });
  };

  const onPage = (page, size) => {
    search({ page: page - 1, size });
  };

  const onPending = (pending) => {
    search({ pending, page: 0 });
  };

  const accept = (item) => {
    Api.report.acceptReport(item.id, "").then(() => {
      refresh();
    });
  };
  const reject = (item) => {
    Api.report.rejectReport(item.id, "").then(() => {
      refresh();
    });
  };

  return {
    data,
    loading,
    refresh,
    onSearch,
    reset,
    onPage,
    filters,
    setFilters,
    onPending,
    accept,
    reject,
    pagination: {
      current: filters.page + 1,
      pageSize: filters.size,
      total: data.total,
      onChange: onPage,
    },
  };
};
